export enum OneProfileEnum {
    ALIAS = "ALIAS",
    AAD_OBJECT_ID = "AAD_OBJECT_ID"
}